<div class="offer-area pt-100">
    <div class="container">
        <div class="section-title">
            <!-- <span class="sub-title">Make Connections</span> -->
            <h2>Hizmetlerimiz</h2>
            <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut nisi ut aliquip ex ea.</p> -->
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-offer-box">
                    <div class="icon">
                        <i class='bx bx-line-chart'></i>
                    </div>
                    <h3>
                        Dijital Reklam Yönetimi</h3>
                    <p>Markanızı hedef kitlenize ulaştıran performans odaklı dijital reklam kampanyaları yönetiyoruz.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-offer-box">
                    <div class="icon">
                        <i class='bx bx-camera'></i>
                    </div>
                    <h3>Fotoğraf ve Video Prodüksüyon</h3>
                    <p>Profesyonel fotoğraf ve video çekimleri ile markanızın hikayesini anlatıyoruz.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
                <div class="single-offer-box">
                    <div class="icon">
                        <i class='bx bxl-instagram'></i>
                    </div>
                    <h3>Sosyal Medya Yönetimi</h3>
                    <p>Etkili içerik stratejileri ve kreatif paylaşımlarla sosyal medyada güçlü bir marka algısı
                        oluşturuyoruz.</p>
                </div>
            </div>
        </div>


    </div>

</div>
<div
    class="my-5 container d-flex flex-lg-row d-sm-flex flex-column justify-content-center align-items-center w-100 gap-4">
    <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
            <div class="single-offer-box">
                <div class="icon">
                    <i class='bx bx-laptop'></i>
                </div>
                <h3>Web Sitesi Tasarımı</h3>
                <p>Mobil uyumlu, hızlı ve kullanıcı dostu web siteleri tasarlayarak dijital varlığınızı güçlendiriyoruz
                </p>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
            <div class="single-offer-box">
                <div class="icon">
                    <i class='bx bxs-phone'></i>
                </div>
                <h3>Mobil Uygulama</h3>
                <p>İhtiyaçlarınıza özel, modern ve kullanıcı dostu mobil uygulamalar tasarlayıp geliştiriyoruz.</p>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="single-offer-box">
                <div class="icon">
                    <i class='bx bx-user-pin'></i>
                </div>
                <h3>Marka ve Pazarlama Stratejisi</h3>
                <p>Markanızı güçlendiren etkili pazarlama stratejileri oluşturuyoruz.</p>
            </div>
        </div>
    </div>


</div>